'use client';
import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { checkIsMobile } from './utils';
const DesktopPrompt = () => {
  const [href, setHref] = useState('');
  useEffect(() => {
    setHref(window.location.href);
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all">
        {/* 顶部装饰条 */}
        <div className="h-2 bg-gradient-to-r from-blue-500 to-indigo-600"></div>
        {/* 提示内容 */}
        <div className="p-8 text-center space-y-6">
          {/* 手机图标 */}
          <div className="w-20 h-20 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-12 h-12 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-800">仅支持移动端访问</h2>
          <p className="text-gray-600">
            该功能专为移动设备设计，请使用手机扫描二维码或直接在移动设备上打开
          </p>

          {/* 模拟二维码区域 */}
          <div className="w-40 h-40 mx-auto bg-gray-100 rounded-md flex items-center justify-center border-2 border-dashed border-gray-200 p-2">
            <QRCodeSVG value={href} className="w-full h-full" />
          </div>
          <p className="text-gray-500 text-sm">或者将链接发送到您的手机</p>
        </div>
      </div>
    </div>
  );
};

export const MobilePermission: React.FC<{
  children: React.JSX.Element;
  disable?: boolean;
}> = ({ children, disable = false }) => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  useEffect(() => {
    const checkMobile = () => {
      // 判断移动端
      const uaResult = checkIsMobile();

      // 判断屏幕宽度是否小于768
      const screenIsMobile = window.innerWidth < 768;

      // 触摸事件检测
      const isTouchDevice =
        'ontouchstart' in window || navigator.maxTouchPoints > 0;

      setIsMobile(uaResult || screenIsMobile || isTouchDevice);
    };

    checkMobile();

    const handleResize = () => {
      checkMobile();
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 如果disable为true，则直接返回children
  if (disable) {
    return children;
  }

  if (isMobile === null) {
    return null;
  }

  return isMobile ? children : <DesktopPrompt />;
};
